import { useState } from "react";
import { ICON_NAMES, Icon } from "@/lib/icons";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const IconPicker = ({ value, onChange, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="w-11 h-11 rounded-lg border border-white/15 bg-black/40 flex items-center justify-center text-[#DCEBFF] hover:border-cyan-400/50">
          <Icon name={value} size={18} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="glass-strong border-white/10 w-64 p-3" data-testid="icon-picker-panel">
        <div className="grid grid-cols-6 gap-2">
          {ICON_NAMES.map((n) => (
            <button key={n} type="button" onClick={() => { onChange(n); setOpen(false); }}
              className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${value === n ? "bg-cyan-400/20 text-cyan-300" : "text-slate-400 hover:bg-white/10"}`}
              data-testid={`icon-opt-${n}`}>
              <Icon name={n} size={16} />
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
